import { IAvailableTimeDto } from "@crunchit/types";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Timeslots from "./Timeslots";
import { useCheckoutSelector } from "store/checkout";
import "./Timepicker.scss";

const getTimepickerErrorTextKey = (isLoading: boolean, availableTimes: IAvailableTimeDto[]) => {
  if (isLoading) {
    return "common:Fetching";
  } else if (!availableTimes || availableTimes.length === 0) {
    // There are no available timeslots for this date
    return "errors:DeliveryMethod.NoAvailableTimes";
  } else {
    return "errors:DeliveryMethod.NoAvailableTimes"; // Default message is no times
  }
};

interface ITimepickerProps {
  isOpen: boolean;
  availableTimes: IAvailableTimeDto[];
  toggleIsOpen: () => void;
  handleTimeSelection: (updatedTimeslot: string) => void;
}

export default function Timepicker(props: ITimepickerProps) {
  const { isOpen, availableTimes } = props;
  const { toggleIsOpen, handleTimeSelection } = props;

  const { t } = useTranslation();
  const { checkoutSession, isLoading: checkoutIsLoading, checkoutInstanceSettings } = useCheckoutSelector();
  const { chosenTimeslot } = checkoutSession;
  const { orderTimeInterval } = checkoutInstanceSettings;

  const inputPlaceholder = chosenTimeslot ? moment.utc(chosenTimeslot).format("HH:mm") : t("checkout:DeliveryMethod.Timepicker");

  return (
    <div className="timepicker">
      <input readOnly placeholder={inputPlaceholder} onClick={toggleIsOpen} className="timepicker-trigger" />

      {!chosenTimeslot && <div className="input-error">{t("errors:DeliveryMethod.TimePicker")}</div>}

      {isOpen && (
        <div className="timepicker-root">
          {availableTimes.length === 0 ? (
            <div className="timepicker-empty">
              <p>{t(getTimepickerErrorTextKey(checkoutIsLoading, availableTimes))}</p>
            </div>
          ) : (
            <div className="timeslot-view">
              <Timeslots orderTimeInterval={orderTimeInterval} availableTimes={availableTimes} handleTimeSelection={handleTimeSelection} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
